define(['./JsonRPCException'], (JsonRPCException) => {

    return ['$q', '$window', 'TransportService', 'CallTrackerService', 'LoggingService', 'BaslerLoggingConstants', function ($q, $window, TransportService, CallTrackerService, LoggingService, BaslerLoggingConstants) {

        return {
            send: function (xCenterType, serviceEndpoint, method, params, callGroups, faultTolerant) {
                CallTrackerService.registerCallStart(callGroups);
                return (
                    TransportService.send(xCenterType, serviceEndpoint, method, params)
                        .then((response) => {
                            CallTrackerService.registerCallSuccess(callGroups);
                            return response;
                        }, (error) => {
                            CallTrackerService.registerCallError(callGroups);

                            const jsonErrorData = error.baseError && error.baseError.data && error.baseError.data.error ? error.baseError.data.error : null;
                            const appError = jsonErrorData && jsonErrorData.data ? jsonErrorData.data.appErrorCode : null;
                            const appCode = jsonErrorData ? jsonErrorData.code : null;
                            const httpStatus = error.baseError ? error.baseError.status : 500;

                            console.error(`JsonRPCService:: app error=${appError}, app code=${appCode}, http status=${httpStatus}`);

                            error.isRetriable = faultTolerant === true || //always 'retriable'                                    //NOSONAR
                                                error.isTimeout || //it is just temporary                                  //NOSONAR
                                                httpStatus === 503 || //it is just temporary                                  //NOSONAR
                                                (httpStatus === 500 && appError === 620); //special temporary error from backend  //NOSONAR
                            error.appCode = appCode;
                            error.appError = appError;

                            if (error.isRetriable) {
                                console.warn('JSON rpc retriable error handling');
                                return $q.reject(error);
                            } else if (TransportService.isSessionExpiredReason(error)) {
                                //refresh the page to get to login page
                                /* mkarvonen: Set reload to true. Some "autentication solutions" does not set proper
                                 * caching headers.
                                 */
                                console.info('JsonRPCService:: isSessionExpiredReason, reloading location to get login page');
                                $window.location.reload(true);
                            } else {
                                LoggingService.logInfo(BaslerLoggingConstants.CONTACTUS, new Error(error && error.baseError && error.baseError.data));
                                //all the rest errors are unrecognised and are unhandlable at this point
                                //they are handled at top level portal/app with generic error handler
                                throw new JsonRPCException(error);
                            }

                        })

                );
            },
        };
    }];
});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/base/JsonRPCService.js